import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import { ToastContainer } from "react-toastify";
import { useQueryParams } from "./common/queryParams";
import Login from "./common/playerLogin";
import TournamentSelector from "./components/tournamentSelector";
import Tournament from "./components/tournament";
import MainMenu from "./components/mainMenu";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import PlannedTournament from "./components/plannedTournament";
import PlannedTournamentSelector from "./components/plannedTournamentSelector";
import PlannedTournamentApi from "./api/plannedTournamentApi";

class App extends Component {
  state = {
    loaded: false,

    staticData: {
      eventInfos: {},
      scoringFormats: {},
      eventVisibilities: {},
      times: {},
      tiers: {},
    },
  };

  async componentDidMount() {
    const { data } = await PlannedTournamentApi.getStaticData();
    this.setState({ staticData: data });
  }

  render() {
    return (
      <React.Fragment>
        <main>
          <MainMenu />
          <Container fluid>
            <ToastContainer />
            <AtsRouter staticData={this.state.staticData} />
          </Container>
        </main>
      </React.Fragment>
    );
  }
}

function AtsRouter(props) {
  const params = useQueryParams();
  if ("signin" in params) {
    return <Login />;
  } else if ("planned" in params) {
    if (params.planned === "all") return <PlannedTournamentSelector staticData={props.staticData} />;
    return <PlannedTournament plannedTournamentId={params.planned} staticData={props.staticData} />;
  } else if ("id" in params) {
    return <Tournament params={params} />;
  } else {
    return <TournamentSelector />;
  }
}

export default App;
